/**
 * Mock excursion data for personal dashboard demo widgets.
 */

export interface ExcursionData {
  id: string
  date: string
  severity: 'High' | 'Medium' | 'Low'
  status: 'Pending Review' | 'Under Investigation' | 'Resolved'
  product: string
  lots: number
  wafers: number
  yieldLoss: string
  headline: string
}

export function getMockExcursions(): ExcursionData[] {
  return [
    {
      id: '199',
      date: '4/23/2026, 13:32',
      severity: 'High',
      status: 'Pending Review',
      product: 'base_1_wat_point',
      lots: 4,
      wafers: 93,
      yieldLoss: '99.6%',
      headline: 'Increased NMOS threshold voltage (Test_N_Vt)',
    },
    {
      id: '237',
      date: '4/29/2026, 11:24',
      severity: 'Medium',
      status: 'Pending Review',
      product: 'ExoTensor X-9000',
      lots: 2,
      wafers: 4,
      yieldLoss: '31.3%',
      headline: 'Elevated PMOS off-state leakage current (Test_Poff)',
    },
    {
      id: '236',
      date: '4/29/2026, 11:02',
      severity: 'Medium',
      status: 'Pending Review',
      product: 'ExoTensor X-9000',
      lots: 2,
      wafers: 4,
      yieldLoss: '31.3%',
      headline: 'Increased PMOS off-state leakage (Test_Poff)',
    },
    {
      id: '235',
      date: '4/28/2026, 13:17',
      severity: 'Medium',
      status: 'Pending Review',
      product: 'ExoTensor X-9000',
      lots: 3,
      wafers: 9,
      yieldLoss: '41.9%',
      headline: 'Elevated sleep current (Sleep_Current)',
    },
    {
      id: '234',
      date: '4/28/2026, 12:57',
      severity: 'Medium',
      status: 'Pending Review',
      product: 'ExoTensor X-9000',
      lots: 3,
      wafers: 9,
      yieldLoss: '41.9%',
      headline: 'Elevated sleep current (Sleep_Current)',
    },
    {
      id: '233',
      date: '4/28/2026, 11:50',
      severity: 'Medium',
      status: 'Pending Review',
      product: 'Synaptix Fabric-Ultra',
      lots: 9,
      wafers: 28,
      yieldLoss: '33.0%',
      headline: 'Increased contact resistance (Test_Rc)',
    },
    {
      id: '232',
      date: '4/27/2026, 14:27',
      severity: 'Medium',
      status: 'Pending Review',
      product: 'ExoTensor X-9000',
      lots: 3,
      wafers: 19,
      yieldLoss: '41.9%',
      headline: 'Lowered low-threshold voltage (Test_Vtl)',
    },
    {
      id: '231',
      date: '4/27/2026, 14:06',
      severity: 'Medium',
      status: 'Pending Review',
      product: 'ExoTensor X-9000',
      lots: 3,
      wafers: 12,
      yieldLoss: '41.9%',
      headline: 'Elevated sleep current (Sleep_Current)',
    },
  ]
}

export function getSeverityDistribution() {
  const excursions = getMockExcursions()
  const high = excursions.filter((e) => e.severity === 'High').length
  const medium = excursions.filter((e) => e.severity === 'Medium').length
  const low = excursions.filter((e) => e.severity === 'Low').length
  const total = excursions.length

  return {
    high: { count: high, percentage: ((high / total) * 100).toFixed(0) },
    medium: { count: medium, percentage: ((medium / total) * 100).toFixed(0) },
    low: { count: low, percentage: ((low / total) * 100).toFixed(0) },
    total,
  }
}

export function getImpactByProduct() {
  const excursions = getMockExcursions()
  const productMap = new Map<string, { lots: number; wafers: number }>()

  excursions.forEach((exc) => {
    if (!productMap.has(exc.product)) {
      productMap.set(exc.product, { lots: 0, wafers: 0 })
    }
    const current = productMap.get(exc.product)!
    current.lots += exc.lots
    current.wafers += exc.wafers
  })

  return Array.from(productMap.entries())
    .map(([product, impact]) => ({
      product,
      lots: impact.lots,
      wafers: impact.wafers,
    }))
    .sort((a, b) => b.wafers - a.wafers)
    .slice(0, 7)
}
